export default __webpack_public_path__ + "static/media/edit.c55c10e8.svg";